import { List, Section } from '@factorialco/deprecated-design-system'
import { CompensationsPayrollConceptsDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import CategoryBlock from 'modules/compensations/pages/settings/PayrollConcepts/CategoryBlock'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { UNCATEGORIZED_CATEGORY } from 'modules/payroll_bundle/lib/constants'
import { PAYROLL_CONCEPT_CATEGORIES } from 'modules/payroll_bundle/lib/constants'

const PayrollConcepts = () => {
  const {
    company: { id: companyId },
  } = useCurrentSession()
  const { loading, data, error } = useQuery(CompensationsPayrollConceptsDocument, {
    variables: {
      companyId,
    },
  })

  const concepts = data?.payroll.concepts || []
  const uncategorizedConcepts = concepts.filter((concept) => !concept.category)

  return (
    <ResponsivePage.Body loading={loading} error={error}>
      <Section.FullWidth
        illustration="settings"
        title={i18n.t('compensations.settings.concepts.section.title')}
        description={i18n.t('compensations.settings.concepts.section.description')}
        size="600"
      >
        {concepts.length > 0 && (
          <>
            <List>
              {PAYROLL_CONCEPT_CATEGORIES.map((category) => (
                <CategoryBlock
                  key={category}
                  category={category}
                  concepts={concepts.filter((concept) => concept.category === category)}
                  legacyPayroll
                />
              ))}
              {uncategorizedConcepts.length > 0 && (
                <CategoryBlock
                  key={UNCATEGORIZED_CATEGORY}
                  category={UNCATEGORIZED_CATEGORY}
                  concepts={uncategorizedConcepts}
                  legacyPayroll
                />
              )}
            </List>
          </>
        )}
      </Section.FullWidth>
    </ResponsivePage.Body>
  )
}

export default PayrollConcepts
